module.exports = __webpack_public_path__ + "static/reactive-love-redux-dda78a0fb3acef50d57c529924f5d4f1.png";